import React from "react";
import { Link } from "gatsby";

const NavLinks = ({ extraClassName }) => {
  const handleDropdownStatus = e => {
    let clickedItem = e.currentTarget.parentNode;
    clickedItem.querySelector(".dropdown-list").classList.toggle("show");
  };
  return (
    <ul className={`main-menu__list ${extraClassName}`}>
      <li>
        <Link to="/">Home</Link>
      </li>
      {/* <li className="dropdown">
        <Link to="/">Home</Link>
        <button aria-label="dropdown toggler" onClick={handleDropdownStatus}>
          <i className="fa fa-angle-down"></i>
        </button>
        <ul className="dropdown-list">
          <li>
            <Link to="/">Home One</Link>
          </li>
          <li>
            <Link to="/index-2">Home Two</Link>
          </li>
          <li className="dropdown">
            <Link to="#">Header Styles</Link>
            <button
              aria-label="dropdown toggler"
              onClick={handleDropdownStatus}
            >
              <i className="fa fa-angle-down"></i>
            </button>
            <ul className="dropdown-list">
              <li>
                <Link to="/">Header One</Link>
              </li>
              <li>
                <Link to="/index-2">Header Two</Link>
              </li>
            </ul>
          </li>
        </ul>
      </li> */}
      <li className="dropdown">
        <Link to="#">About us</Link>
        <button aria-label="dropdown toggler" onClick={handleDropdownStatus}>
          <i className="fa fa-angle-down"></i>
        </button>
        <ul className="dropdown-list">
          <li>
            <Link to="/about-jci">About JCI</Link>
          </li>
          <li>
            <Link to="/about-jci-india">JCI India</Link>
          </li>
          <li>
            <a href="http://jci.cc/" target="_blank">
              JCI Global
            </a>
          </li>
        </ul>
      </li>
      <li className="dropdown">
        <Link to="#">Team</Link>
        <button aria-label="dropdown toggler" onClick={handleDropdownStatus}>
          <i className="fa fa-angle-down"></i>
        </button>
        <ul className="dropdown-list">
          <li>
            <Link to="/team/national-governing-board">
              National Governing Board
            </Link>
          </li>
          <li>
            <Link to="/team/zone-governing-board">Zone Governing Board</Link>
          </li>
          {/* <li>
            <Link to="/team/lom-governing-board">LO Governing Board</Link>
          </li> */}
          <li>
            <Link to="/team/national-committees">National Committees</Link>
          </li>
          <li>
            <Link to="/team/nom-coordinators">NOM Coordinator</Link>
          </li>
          <li>
            <Link to="/team/past-national-presidents">Past National Presidents</Link>
          </li>
          <li>
            <Link to="/team/jci-india-nhq-staffs">JCI India NHQ</Link>
          </li>
        </ul>
      </li>
      <li className="dropdown">
        <Link to="#">Events</Link>
        <button aria-label="dropdown toggler" onClick={handleDropdownStatus}>
          <i className="fa fa-angle-down"></i>
        </button>
        <ul className="dropdown-list">
          <li>
            <Link to="/events/national-events">National Events</Link>
          </li>
          <li>
            <Link to="/events/zone-events">Zone Events</Link>
          </li>
          <li>
            <Link to="/events/lo-events">LO Events</Link>
          </li>
          <li>
            <a href="https://awards.jciindia.in" target="_blank">
              Awards Bidding Portal
            </a>
          </li>
        </ul>
      </li>
      {/* <li className="dropdown">
        <Link to="#">News</Link>
        <button aria-label="dropdown toggler" onClick={handleDropdownStatus}>
          <i className="fa fa-angle-down"></i>
        </button>
        <ul className="dropdown-list">
          <li>
            <Link to="/news">News</Link>
          </li>
          <li>
            <Link to="/news-details">News Details</Link>
          </li>
        </ul>
      </li> */}
      <li className="dropdown">
        <Link to="#">Programs</Link>
        <button aria-label="dropdown toggler" onClick={handleDropdownStatus}>
          <i className="fa fa-angle-down"></i>
        </button>
        <ul className="dropdown-list">
          <li>
            <Link to="/programs/national-programs">National Programs</Link>
          </li>
          {/* <li>
            <Link to="/programs/zone-programs">Zone Programs</Link>
          </li> */}
        </ul>
      </li>
      <li>
        <Link to="/gallery">Gallery</Link>
      </li>
      <li>
        <Link to="/downloads">Downloads</Link>
      </li>
      <li>
        <Link to="/contact">Contact</Link>
      </li>
      {/* <li>
        <Link to="/testing">Testing</Link>
      </li> */}
      {/* <li className="search-btn search-toggler">
        <span>
          <i className="azino-icon-magnifying-glass"></i>
        </span>
      </li> */}
    </ul>
  );
};

export default NavLinks;
